// extracted by mini-css-extract-plugin
module.exports = {"qualitySelector":"hf","label":"hh","downloadSize":"hi","selectorWrapper":"hj","selected":"hk"};